module.exports = __webpack_public_path__ + "static/img/premiere_icon.3351c86d.png";